import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-82c853de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tips"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-icon"
}, null, -1));

const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = ["href", "target"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page_header", {
      circle: $props.isCircle
    }]),
    style: _normalizeStyle($props.bodyStyle)
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "tips", {}, undefined, true)]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "left", {}, undefined, true)]), _createElementVNode("a", {
    href: $props.link,
    target: $props.openOut ? '_blank' : '_self',
    class: "right"
  }, [_renderSlot(_ctx.$slots, "right", {}, undefined, true)], 8, _hoisted_5)])], 6);
}